module.exports = __webpack_public_path__ + "img/icon-spicy.2eb8213c.svg";